module.exports = __webpack_public_path__ + "static/faster-deployment-d43af32930d355d485c01a45e2f6d015.svg";